import { AppService } from '../main/app.service';
import { BaseService } from '../base/base.service';

export class SettingsService extends BaseService<any> {
 
    constructor(protected Restangular: Restangular.IService, protected AppService: AppService) {
        "ngInject";
        super(Restangular, AppService, 'settings');
    }
}


// WEBPACK FOOTER //
// ./src/app/services/settings.service.ts